import Index from '@/views/Index'
import Second from '@/views/common/Second'
const SetView = (view) => { return (resolve) => require([`@/views/${view}`], resolve) }
export default (routers, data) => {
  generaMenu(routers, data)
}
function generaMenu(routers, data) {
  data.forEach(item => {
    const menu = Object.assign({}, item)
    if (menu.component === 'Index') {
      menu.component = Index
    }else if (menu.component === 'Second') {
      menu.component = Second
    } else {
      menu.component = SetView(menu.component)
    }
    if (item.children && item.children.length > 0) {
      menu.children = []
      generaMenu(menu.children, item.children)
    }
    routers.push(menu)
  })

  return routers
}



// WEBPACK FOOTER //
// ./src/utils/menu.js